import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { siteInfo } from '@/mocks/incidents';

const navItems = [
  { label: '首页', to: '/' },
  { label: '案件通报', to: '/cases' },
  { label: '关于我们', to: '/about' },
];

const tickerItems = [
  '果敢地区一处电诈园区夜间被查，多批涉案人员集中移交',
  '妙瓦底方向被困人员分批返回，家属线索报备持续推进',
  '公开提示汇总：警惕以高薪务工为名的境外诱骗招募',
  '通信与支付工具双向收紧，跨境诈骗作案成本上升',
];

export default function SiteHeader() {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  const isActive = (to: string) => {
    if (to === '/') return location.pathname === '/';
    return location.pathname.startsWith(to);
  };

  const isHome = location.pathname === '/';
  const BrandTag = isHome ? 'h1' : 'div';

  return (
    <header className="sticky top-0 z-50 w-full">
      <div className="w-full bg-foreground-950 text-background-100">
        <div className="mx-auto flex max-w-content items-center gap-4 px-4 py-2 md:px-6">
          <span className="flex shrink-0 items-center gap-1.5 text-[11px] font-medium tracking-wide text-accent-400">
            <span className="flex h-2 w-2 items-center justify-center">
              <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-accent-500"></span>
            </span>
            最新动态
          </span>
          <div className="relative flex-1 overflow-hidden">
            <div className="flex w-max animate-marquee gap-12 whitespace-nowrap text-xs text-background-200">
              {[...tickerItems, ...tickerItems].map((item, index) => (
                <span key={index} className="flex items-center gap-2">
                  <i className="ri-arrow-right-s-line text-accent-500"></i>
                  {item}
                </span>
              ))}
            </div>
          </div>
          <span className="hidden shrink-0 text-[11px] text-background-400 md:block">
            更新于 {siteInfo.updatedAt}
          </span>
        </div>
      </div>

      <div className="w-full border-b border-background-200 bg-background-50/95 backdrop-blur">
        <div className="mx-auto flex max-w-content items-center justify-between px-4 py-3 md:px-6 md:py-4">
          <Link to="/" className="group flex items-center gap-3">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-600 text-background-50">
              <i className="ri-radar-line text-lg"></i>
            </span>
            <BrandTag className="flex flex-col leading-none">
              <span className="m-0 font-heading text-lg font-bold tracking-tight text-foreground-950 md:text-xl">
                {siteInfo.name}
              </span>
              <span className="mt-0.5 text-[10px] tracking-[0.2em] text-foreground-500">
                {siteInfo.slogan}
              </span>
            </BrandTag>
          </Link>

          <nav className="hidden items-center gap-1 md:flex">
            {navItems.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                className={`whitespace-nowrap rounded-md px-4 py-2 text-sm font-medium transition-colors ${
                  isActive(item.to)
                    ? 'bg-primary-50 text-primary-700'
                    : 'text-foreground-700 hover:bg-background-100 hover:text-foreground-950'
                }`}
              >
                {item.label}
              </Link>
            ))}
            <Link
              to="/cases"
              className="ml-2 flex items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-600 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-700"
            >
              <i className="ri-search-eye-line"></i>
              查看通报
            </Link>
          </nav>

          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setMenuOpen((prev) => !prev)}
            className="flex h-10 w-10 items-center justify-center rounded-md text-foreground-800 transition-colors hover:bg-background-100 md:hidden"
          >
            <i className={menuOpen ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'}></i>
          </button>
        </div>

        {menuOpen && (
          <div className="border-t border-background-200 bg-background-50 md:hidden">
            <nav className="mx-auto flex max-w-content flex-col px-4 py-3">
              {navItems.map((item) => (
                <Link
                  key={item.to}
                  to={item.to}
                  onClick={() => setMenuOpen(false)}
                  className={`flex items-center justify-between rounded-md px-4 py-3 text-sm font-medium transition-colors ${
                    isActive(item.to)
                      ? 'bg-primary-50 text-primary-700'
                      : 'text-foreground-700 hover:bg-background-100'
                  }`}
                >
                  {item.label}
                  <i className="ri-arrow-right-s-line"></i>
                </Link>
              ))}
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}